export default "__VITE_ASSET__BaJyyq1v__"